// removed by extract-text-webpack-plugin
module.exports = {"lightPurple":"#e2c0f9","purple":"#9800ff","medium-max":"(max-width:768px)","content":"home__content___3tW4M","isActive":"home__isActive___2_7PL"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/home.css
// module id = 173
// module chunks = 0